import { EmptyInstance } from "core/features/components/mixins/empty-instance";
import { EventEmitterMixin } from "front-end/mixins/event-emitter.mixin";
import { TeamMembersProfileModel } from "./models/team-members-profile.model";

export class TeamMembersProfileModalComponent extends EventEmitterMixin(EmptyInstance) {
    public static SELECTOR: string = ".js-ina-our-people-profile-modal";

    private _currentContext: JQuery = $();

    private _classMap = {
        js: {
            name: `${TeamMembersProfileModalComponent.SELECTOR}__name`,
            position: `${TeamMembersProfileModalComponent.SELECTOR}__position`,
            shortDescription: `${TeamMembersProfileModalComponent.SELECTOR}__description`,
            imgSrcSet: `${TeamMembersProfileModalComponent.SELECTOR}__img_srcset`,
            imgSrc: `${TeamMembersProfileModalComponent.SELECTOR}__img_src`
        }
    };

    private _name: JQuery;
    private _position: JQuery;
    private _shortDescription: JQuery;
    private _imgSrc: JQuery;

    private _currentTeamProfile: TeamMembersProfileModel = null;

    public setProfile(profile: TeamMembersProfileModel): TeamMembersProfileModalComponent {
        this._currentTeamProfile = profile;
        return this;
    }

    public setName(name: string) : TeamMembersProfileModalComponent{
        this._name.html(name);
        return this;
    }

    public setPosition(position: string): TeamMembersProfileModalComponent {
        this._position.html(position);
        return this;
    }

    public setDescription(description: string): TeamMembersProfileModalComponent {
        this._shortDescription.html(description);
        return this;
    }

    public setImageSrc(imageSrc: string): TeamMembersProfileModalComponent {
        if (imageSrc) {
            this._imgSrc.attr("src", imageSrc);
        }
        this._imgSrc.toggle(!!imageSrc);
        return this;
    }

    public show(): void {
        this._currentContext.modal("show");
    }

    public render(): TeamMembersProfileModalComponent {
        this.setName(this._currentTeamProfile.name)
            .setPosition(this._currentTeamProfile.position)
            .setDescription(this._currentTeamProfile.shortDescription)
            .setImageSrc(this._currentTeamProfile.imageSrc);

        return this;
    }

    private bindEvents(): void {
        this._currentContext.on("hidden.bs.modal", () => this.setProfile(null));
    }

    private parseContext(): void {
        this._name = $(this._classMap.js.name, this._currentContext);
        this._position = $(this._classMap.js.position, this._currentContext);
        this._shortDescription = $(this._classMap.js.shortDescription, this._currentContext);
        this._imgSrc = $(this._classMap.js.imgSrc, this._currentContext);
    }

    public init(context: JQuery): void {
        this._currentContext = context || this._currentContext;

        this.parseContext();
        this.bindEvents();
    }
}
